module.exports = __webpack_public_path__ + "static/media/1024939.27760951.png";